import { AdoptionWidget } from "./AdoptionWidget/AdoptionWidget";
import { EngagementWidget } from "./EngagementWidget/EngagementWidget";
import { FahWidget } from "./FahWidget/FahWidget";
import { SocialContributionWidget } from "./SocialContributionWidget/SocialContributionWidget";

export const Analytics = {
  AdoptionWidget,
  FahWidget,
  EngagementWidget,
  SocialContributionWidget,
};
